import Service, { service } from '@ember/service';
import { timeout } from 'ember-concurrency';
import type cookies from 'ember-simple-auth/session-stores/cookies';
import urlBuilder from 'garaje/utils/url-builder';
import { wrappedFetch } from 'garaje/utils/wrapped-fetch';

export type AnalyticsSettingsResponse = {
  id: string;
  company_id: number;
  manager_access_enabled: boolean;
};

export default class AnalyticsSettingsService extends Service {
  @service declare cookies: cookies;

  async getAnalyticsSettings(companyId: string): Promise<AnalyticsSettingsResponse> {
    const url = urlBuilder.analytics.getAnalyticsSettingsUrl(companyId);
    try {
      const csrfToken = this.cookies.read('csrf_token') as string;
      const headers = {
        'X-CSRF-Token': csrfToken,
      };
      const response = await Promise.race([
        wrappedFetch(url, {
          credentials: 'include',
          headers,
          method: 'GET',
        }),
        timeout(15000).then(() => {
          throw new Error('Timeout exceeded while fetching analytics settings');
        }),
      ]);

      if (!response.ok) {
        throw new Error(`Failed to fetch settings ${response.status}`);
      }

      const data = (await response.json()) as AnalyticsSettingsResponse;
      return data;
    } catch (e) {
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions, no-console
      console.error(`Error fetching settings: ${e}`);

      // Return default values on error
      return {
        id: '',
        company_id: parseInt(companyId),
        manager_access_enabled: false,
      };
    }
  }
}
